export default "__VITE_ASSET__f7f092f3__"